import { Drawer, OnClickFunction, PathBuilder, StyleForPath, StyleForText } from "@common/components/Rendering";
import { ArrowId, cs_hook_dist, cs_view_size } from "../ViewportStyles";

export const drawViewDirection_up_left = (
  drawer: Drawer<ArrowId>,
  a_style: StyleForText & StyleForPath,
  sett: {
    hor: number;
    ver: number;
    onClicked: OnClickFunction;
  },
) => {
  const view_dist = sett.hor;
  const label = drawer.drawText([view_dist - cs_hook_dist, sett.ver - cs_view_size], "XY", a_style, {
    vertAlign: "middle",
    horiAlign: "center",
    horiOffset: 0,
    vertOffset: -(a_style.textSize as number) * 0.7,
  });
  drawer.drawPath(
    a_style,
    new PathBuilder()
      .moveTo([view_dist, sett.ver + cs_view_size / 2])
      .drawLineTo([view_dist - cs_hook_dist, sett.ver + cs_view_size / 2])
      .drawLineTo([view_dist - cs_hook_dist, sett.ver - cs_view_size / 2]),
    {
      onClicked: sett.onClicked,
      endArrow: "view-direction-arrow",
      hitAreaRect: [label],
    },
  );
};

export const drawViewDirection_up_right = (
  drawer: Drawer<ArrowId>,
  a_style: StyleForText & StyleForPath,
  sett: {
    hor: number;
    ver: number;
    onClicked: OnClickFunction;
  },
) => {
  const view_dist = sett.hor;
  const label = drawer.drawText([view_dist + cs_hook_dist, sett.ver - cs_view_size], "XY", a_style, {
    vertAlign: "middle",
    horiAlign: "center",
    horiOffset: 0,
    vertOffset: -(a_style.textSize as number) * 0.7,
  });
  drawer.drawPath(
    a_style,
    new PathBuilder()
      .moveTo([view_dist, sett.ver + cs_view_size / 2])
      .drawLineTo([view_dist + cs_hook_dist, sett.ver + cs_view_size / 2])
      .drawLineTo([view_dist + cs_hook_dist, sett.ver - cs_view_size / 2]),
    {
      onClicked: sett.onClicked,
      endArrow: "view-direction-arrow",
      hitAreaRect: [label],
    },
  );
};

export const drawViewDirection_left_top = (
  drawer: Drawer<ArrowId>,
  b_style: StyleForText & StyleForPath,
  sett: {
    hor: number;
    ver: number;
    onClicked: OnClickFunction;
  },
) => {
  const view_dist = sett.ver;
  const width = sett.hor;
  const label = drawer.drawText([width - cs_view_size, view_dist - cs_hook_dist], "XZ", b_style, {
    vertAlign: "middle",
    horiAlign: "center",
    horiOffset: -(b_style.textSize as number),
    vertOffset: (b_style.textSize as number) / 8,
  });
  drawer.drawPath(
    b_style,
    new PathBuilder()
      .moveTo([width + cs_view_size / 2, view_dist])
      .drawLineTo([width + cs_view_size / 2, view_dist - cs_hook_dist])
      .drawLineTo([width - cs_view_size / 2, view_dist - cs_hook_dist]),
    {
      onClicked: sett.onClicked,
      endArrow: "view-direction-arrow",
      hitAreaRect: [label],
    },
  );
};

export const drawViewDirection_left_bottom = (
  drawer: Drawer<ArrowId>,
  b_style: StyleForText & StyleForPath,
  sett: {
    hor: number;
    ver: number;
    onClicked: OnClickFunction;
  },
) => {
  const view_dist = sett.ver;
  const width = sett.hor;
  const label = drawer.drawText([width - cs_view_size, view_dist + cs_hook_dist], "XZ", b_style, {
    vertAlign: "middle",
    horiAlign: "center",
    horiOffset: -(b_style.textSize as number),
    vertOffset: (b_style.textSize as number) / 8,
  });
  drawer.drawPath(
    b_style,
    new PathBuilder()
      .moveTo([width + cs_view_size / 2, view_dist])
      .drawLineTo([width + cs_view_size / 2, view_dist + cs_hook_dist])
      .drawLineTo([width - cs_view_size / 2, view_dist + cs_hook_dist]),
    {
      onClicked: sett.onClicked,
      endArrow: "view-direction-arrow",
      hitAreaRect: [label],
    },
  );
};
